import OperationsPage from 'views/Pages/OperationsPage.jsx'
import LoginPage from 'views/Pages/LoginPage.jsx'
import RegisterPage from 'views/Pages/RegisterPage.jsx'
import ResetPwdPage from 'views/Pages/ResetPwdPage.jsx'
import ConsumerRequestPage from 'views/Pages/ConsumerRequestPage'
import ConsumerNewRequestPage from 'views/Pages/ConsumerNewRequestPage'
import ProfilePage from 'views/Pages/ProfilePage'
import PersonAdd from '@material-ui/icons/PersonAdd'
import Fingerprint from '@material-ui/icons/Fingerprint'
import Home from '@material-ui/icons/Home'
import LockOpen from '@material-ui/icons/LockOpen'
import AddToQueue from '@material-ui/icons/AddToQueue'
import Storage from '@material-ui/icons/Storage'
import AccountCircle from '@material-ui/icons/AccountCircle'
import translation from '../translation/translate'
import RecapParticipation from 'views/Pages/RecapParticipation'

const client = process.env.REACT_APP_CLIENT

const pagesRoutes = [
  {
    path: '/',
    name: 'Home',
    short: 'Accueil',
    mini: 'HM',
    requireAuth: true,
    icon: Home,
    component: OperationsPage
  },
  {
    path: '/nouvelle-demande/:ope_id',
    name: 'Nouvelle demande',
    short: 'Nouvelle',
    requireAuth: true,
    mini: 'New',
    icon: AddToQueue,
    noHeader: true,
    component: ConsumerNewRequestPage
  },
  {
    path: '/modifier-demande/:ope_id/part/:part_id',
    name: 'Modifier demande',
    short: 'Modifier',
    requireAuth: true,
    mini: 'Modif',
    icon: AddToQueue,
    noHeader: true,
    component: ConsumerNewRequestPage
  },
  {
    path: '/recap-participation/:ope_id',
    name: 'Recap participation',
    short: 'Recap',
    requireAuth: true,
    mini: 'New',
    icon: AddToQueue,
    noHeader: true,
    component: RecapParticipation
  },
  {
    path: '/mes-demandes',
    name: 'Mes demandes',
    short: translation[client].navbar_demandes,
    requireAuth: true,
    mini: 'Dem',
    icon: Storage,
    component: ConsumerRequestPage
  },
  {
    path: '/inscription',
    name: 'Inscription',
    short: 'Inscription',
    mini: 'ISC',
    icon: PersonAdd,
    requireAuth: false,
    component: RegisterPage
  },
  {
    path: '/login',
    name: 'Connexion',
    short: 'Connexion',
    mini: 'CNX',
    icon: Fingerprint,
    requireAuth: false,
    component: LoginPage
  },
  {
    path: '/reiniialiser-mot-de-passe/:token',
    name: 'Reset PWD',
    short: 'Reset PWd',
    noHeader: true,
    mini: 'PWD',
    icon: LockOpen,
    component: ResetPwdPage
  },
  {
    path: '/mon-profil',
    name: 'profil',
    short: 'Mon Profil',
    requireAuth: true,
    mini: 'Profil',
    icon: AccountCircle,
    component: ProfilePage
  },
  {
    redirect: true,
    path: '/',
    pathTo: '/',
    name: 'Page non trouvée'
  }
];

export default pagesRoutes;



// WEBPACK FOOTER //
// ./src/routes/pages.jsx